import SitesGrid from '../../components/grids/SitesGrid'
import AddSiteForm from '../../components/FormComps/Sites/AddSiteForm'
import EditSiteForm from '../../components/FormComps/Sites/EditSiteForm';

import { useState, useEffect } from 'react'
import { useToast } from '../../contexts/ToastContext';

import { Drawer, DrawerContent, DrawerNavigation } from "@progress/kendo-react-layout";
import { FaTimesCircle } from 'react-icons/fa'
import { submitSite, updateSite, getSites, deleteSite } from '../../data/siteData'
import { getSiteTypes } from '../../data/interfaces'

import '../Styles.css'

const Sites = () => {
    const [siteData, setSiteData] = useState<getSiteTypes[]>([])
    const [expanded, setExpanded] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [addFormVisible, setAddFormVisible] = useState(false);
    const [siteId, setSiteId] = useState(0);
    const { showToast } = useToast();

    const [showDeleted, setShowDeleted] = useState(false);

    const handleRejected = (value: boolean) => {
        setShowDeleted(value);
    }

    const handleAddForm = () => {
        setAddFormVisible((prevState) => !prevState ? true : true);
        setEditFormVisible(false)
        handleExpanded();
    };

    const handleEditForm = (id: number) => {
        setSiteId(id);
        setEditFormVisible((prevState) => !prevState ? true : true);
        setAddFormVisible(false)
        handleExpanded();
    };

    const updateSiteHandler = (dataItem: any, id: number) => {
        const siteObj = {
            siteId: id,
            siteAddr: dataItem.siteAddr,
            postcode: dataItem.postcode,
        }
        updateSite(siteObj, id)
            .then(() => {
                const fetchData = async () => {
                    const siteData = await getSites(showDeleted);
                    setSiteData(siteData)
                }
                fetchData()
            })
        handleExpanded()
        showToast('Site succesfully updated', 'success');
    };

    const newSiteHandler = (dataItem: any) => {
        const siteObj = {
            siteAddr: dataItem.siteAddr,
            postcode: dataItem.postcode,
        }
        submitSite(siteObj)
            .then(() => {
                const fetchData = async () => {
                    const siteData = await getSites(showDeleted);
                    setSiteData(siteData)
                }
                fetchData()
            })
        handleExpanded()
        showToast('Site succesfully added', 'success');
    };

    useEffect(() => {
        const fetchData = async () => {
            const sitesData = await getSites(showDeleted);
            setSiteData(sitesData);
        };

        fetchData();
    }, [showDeleted]);

    const deleteSiteHandler = (id: number) => {
        deleteSite(id)
        setSiteData(siteData.filter((site: any) => site.siteId !== id));
        handleExpanded()
        showToast('Site succesfully deleted', 'success');
    }

    const handleExpanded = () => {
        setExpanded((prevState) => !prevState);

        if (editFormVisible) {
            setEditFormVisible(false)
        }
        if (addFormVisible) {
            setAddFormVisible(false)
        }
    }

    const handleSelect = () => {
        setExpanded(false);
    };


    return (
        <div>
            <Drawer
                expanded={expanded}
                position={"end"}
                width={750}
                mode="overlay"
                animation={{
                    duration: 400,
                }}
                onOverlayClick={handleExpanded}
                onSelect={handleSelect}
            >
                <DrawerContent>
                    <DrawerNavigation>
                        {addFormVisible && (
                            <>
                                <div className='form__title__container'>
                                    <h1 className='form__title'>Add Site</h1>
                                    <FaTimesCircle className='closeform' onClick={handleExpanded} />
                                </div>
                                <div className='form__wrapper'>
                                    <AddSiteForm onSiteSubmit={newSiteHandler} />
                                </div>
                            </>
                        )}

                        {editFormVisible && (
                            <>
                                <div className='form__title__container'>
                                    <h1 className='form__title'>Edit Site</h1>
                                    <FaTimesCircle className='closeform' onClick={handleExpanded} />
                                </div>
                                <EditSiteForm
                                    onEditSubmit={updateSiteHandler}
                                    onSiteId={siteId}
                                    onSiteDelete={deleteSiteHandler}
                                />
                            </>
                        )}
                    </DrawerNavigation>

                    <SitesGrid
                        onAddToggle={handleAddForm}
                        onEditToggle={handleEditForm}
                        onData={siteData}
                        onShowDeleted={handleRejected}
                    />
                </DrawerContent>
            </Drawer>
        </div>
    )
}

export default Sites